import { createAsyncThunk } from '@reduxjs/toolkit';
import { getErrorPayload } from '@application/helpers/api-helper';
import familyFestFaqQuestionApi from '@infrastructure/family-fest-faq-question-api';
export const getFamilyFestFaqQuestionsByCategoryIdAsync = createAsyncThunk('familyFestFaqQuestion/getByCategoryId', async (request, { rejectWithValue }) => {
    try {
        const response = await familyFestFaqQuestionApi.getFamilyFestFaqQuestionsByCategoryId(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getFamilyFestFaqQuestionByIdAsync = createAsyncThunk('familyFestFaqQuestion/getById', async (id, { rejectWithValue }) => {
    try {
        const response = await familyFestFaqQuestionApi.getFamilyFestFaqQuestionById(id);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const createFamilyFestFaqQuestionAsync = createAsyncThunk('familyFestFaqQuestion/create', async (request, { rejectWithValue }) => {
    try {
        const response = await familyFestFaqQuestionApi.createFamilyFestFaqQuestion(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateFamilyFestFaqQuestionAsync = createAsyncThunk('familyFestFaqQuestion/update', async (request, { rejectWithValue }) => {
    try {
        const response = await familyFestFaqQuestionApi.updateFamilyFestFaqQuestion(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteFamilyFestFaqQuestionAsync = createAsyncThunk('familyFestFaqQuestion/delete', async (id, { rejectWithValue }) => {
    try {
        const response = await familyFestFaqQuestionApi.deleteFamilyFestFaqQuestion(id);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const reorderFamilyFestFaqQuestionsAsync = createAsyncThunk('familyFestFaqQuestion/reorder', async (request, { rejectWithValue }) => {
    try {
        const response = await familyFestFaqQuestionApi.reorderFamilyFestFaqQuestions(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
